export default class RecaptchaResponse {
  public success = false
  public message: string | null = null
}
